import { getSafePermissions, hasAnyPermission } from './permissions';
import { getDefaultAdminPath } from './adminNavConfig';
import { PERMISSIONS } from './permissionConstants';
import { readAuthFromStorage, normalizeRoleName, getRoleName } from './auth';

export const getUserPermissionsFromAuth = (authState) => {
  const stored = readAuthFromStorage();
  const auth = authState || stored || {};
  return getSafePermissions(
    auth.permissions ||
      auth.user?.permissions ||
      stored?.permissions ||
      stored?.user?.permissions ||
      []
  );
};

export const canAccessAny = (userPermissions, requiredPermissions) => {
  if (!requiredPermissions?.length) return true;
  return hasAnyPermission(userPermissions, requiredPermissions);
};

export const isAffiliateRole = (role) =>
  normalizeRoleName(getRoleName(role)) === 'affiliate';

export const isStaffRole = (role) => {
  const name = normalizeRoleName(getRoleName(role));
  return Boolean(name && name !== 'affiliate');
};

export const getStaffRedirectPath = (role, userPermissions) => {
  const roleName = normalizeRoleName(getRoleName(role));
  if (roleName === 'affiliate') return '/dashboard';
  if (roleName === 'sales') {
    const salesDashPerms = [
      PERMISSIONS.SALES_DASHBOARD,
      PERMISSIONS.SALES_DASHBOARD_VIEW,
    ];
    if (hasAnyPermission(userPermissions, salesDashPerms)) {
      return '/admin/sales-dashboard';
    }
    const estimatePerms = [
      PERMISSIONS.ESTIMATE_REQUEST,
      PERMISSIONS.ESTIMATE_REQUEST_VIEW,
      PERMISSIONS.ESTIMATE_REQUEST_ADD,
    ];
    if (hasAnyPermission(userPermissions, estimatePerms)) {
      return '/admin/estimate-requests';
    }
  }
  return getDefaultAdminPath(userPermissions);
};
